export const dragBackground = '#555';
export const cardSpaceHeight = 50;
